module.exports = __webpack_public_path__ + "img/image11.830a0434.png";